/* ============================================================
   S3 Section Curves — z-index stacking resolver
   ------------------------------------------------------------
   The "Section curve" feature rounds a section's top/bottom
   corners and pulls the neighbouring section into the gap with
   a negative margin, so the neighbour's background shows through
   the curve. For that to read, the section that OWNS the curve
   must paint ABOVE the neighbour it overlaps.

   Inline CSS gives every curved section z-index:2 as a no-JS
   fallback. That breaks down when two adjacent sections are both
   curved (e.g. a stack of bottom curves): equal z-index means the
   later one in the DOM paints over the earlier one's curve.

   This script reads the --s3-curve-top / --s3-curve-bottom flags
   that each curved section sets on its #shopify-section-… wrapper
   and raises each curve owner above the neighbour it overlaps, so
   any applied curve is always visible. Only curved wrappers are
   touched; everything else is left alone.
   ============================================================ */
(function () {
  if (window.__s3CurveStack) return;
  window.__s3CurveStack = true;

  function flag(el, prop) {
    return getComputedStyle(el).getPropertyValue(prop).trim() === '1';
  }

  function restack() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll('[id^="shopify-section-"]')
    );
    if (!nodes.length) return;

    var sections = nodes.map(function (el) {
      return { el: el, top: flag(el, '--s3-curve-top'), bottom: flag(el, '--s3-curve-bottom') };
    });

    var anyCurve = sections.some(function (s) { return s.top || s.bottom; });
    if (!anyCurve) return;

    // Base: curved sections sit on z:2 (matches the no-JS fallback);
    // non-curved sections are left untouched (z stays null).
    sections.forEach(function (s) { s.z = (s.top || s.bottom) ? 2 : null; });

    // Relax pairwise constraints over adjacent sections until stable.
    // At a boundary between A (upper) and B (lower):
    //   • A's bottom curve must beat B  — unless B claims the boundary with a top curve.
    //   • B's top curve must beat A      — unless A claims the boundary with a bottom curve.
    // When both claim it, the lower section's top curve wins by DOM order (no change).
    var changed = true;
    var guard = 0;
    while (changed && guard++ < sections.length + 2) {
      changed = false;
      for (var i = 0; i < sections.length - 1; i++) {
        var A = sections[i];
        var B = sections[i + 1];
        if (A.bottom && !B.top) {
          var bz = B.z == null ? 0 : B.z;
          if ((A.z == null ? 0 : A.z) <= bz) { A.z = bz + 1; changed = true; }
        }
        if (B.top && !A.bottom) {
          var az = A.z == null ? 0 : A.z;
          if ((B.z == null ? 0 : B.z) <= az) { B.z = az + 1; changed = true; }
        }
      }
    }

    sections.forEach(function (s) {
      if (s.z == null) return;
      if (!s.el.style.position) s.el.style.position = 'relative';
      s.el.style.zIndex = s.z;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restack);
  } else {
    restack();
  }
  // Theme editor: sections can be added/removed/reordered live.
  document.addEventListener('shopify:section:load', restack);
  document.addEventListener('shopify:section:unload', restack);
  document.addEventListener('shopify:section:reorder', restack);
})();
